import { Paper } from '@mui/material';
import React from 'react';

export default class RefExampleSource extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  changeTextOfRef() {
    this.props.callRef.current.setState({
      text: 'Más Valami',
      counter: this.props.callRef.current.state.counter + 1,
    });
  }

  clearRef() {
    this.props.callRef.current.clear();
  }

  render() {
    return (
      <Paper
        elevation={6}
        className='border p-1 m-1'
      >
        <h2>Source component</h2>
        <div>This is the RefExampleSource component.</div>
        <div>Onclick of the first button changes the state.text of the ref component.</div>
        <div>Onclick of the second button calls the inner clear() function of the ref component.</div>
        <input
          type='button'
          value='Change text of the destination component'
          onClick={this.changeTextOfRef.bind(this)}
        />
        &nbsp;
        <input
          type='button'
          value='Clear the destination component'
          onClick={this.clearRef.bind(this)}
        />
      </Paper>
    );
  }
}
